import { render, staticRenderFns } from "./confirmTip.vue?vue&type=template&id=6c69a796&scoped=true&"
import script from "./confirmTip.vue?vue&type=script&lang=js&"
export * from "./confirmTip.vue?vue&type=script&lang=js&"
import style0 from "./confirmTip.vue?vue&type=style&index=0&id=6c69a796&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c69a796",
  null
  
)

export default component.exports